<script lang="ts" setup>
	import { useMarketingStore } from '@/store/marketing.store';
	import { useModalStore } from '@/store/modal.store';
	import { ISignUpLink } from '@/types';
  import {computed, ref, watch} from 'vue';
	import { useRoute } from 'vue-router';

  const props = defineProps<{
    closeSignal?: boolean
  }>();

  watch(() => props.closeSignal, () => {
    if (props.closeSignal) {
      close();
    }
  });

	const modalStore = useModalStore();
	const marketingStore = useMarketingStore();
	const route = useRoute();
	
	const groupId = computed<string>(() => String(route.params.groupId || ''));

	const newLink = ref<ISignUpLink>({
		id: 0,
		name: '',
		created: Date.now(),
		lastUsed: 0,
		createdBy: '-',
		visited: 0,
		subscribers: 0,
	});

	const createLink = ():void => {
		marketingStore.createSignUpLink(newLink.value)
			.then(() => {
				modalStore.closeModal();
			})
	};
</script>


<template>
	<div class="modal modal--active">
		<div class="modal__body">
			<div class="modal__header">
				<p class="modal__subtitle">
					<span class="material-symbols-outlined">person</span>
					<span>New Link</span>
				</p>
				<button @click="modalStore.closeModal" class="modal__close">
					<span class="material-symbols-outlined">close</span>
				</button>
			</div>
			<div class="modal__main" >

				<div class="login__item">
					<input
						v-model="newLink.name"
						class="input"
						placeholder="Company Name*">

				</div>

				<button type="button" class="login__btn" @click="createLink">Continue</button>
			</div>
		</div>
	</div>
</template>

